import React, { FC, useEffect, useState } from "react";
import { useStoreActions, useStoreState } from "../../store";
import { Aligment, IListItem, List } from "venice-ui";
import { dictionary } from "../../untils/dictionary";
import { t } from "../../helpers/userHelper";
import { apiCall } from "../../untils/apiCall";
import { EmptyState } from "../UI/EmptyState";
import {
  OrganizationDetailsWrapper,
  OrganizationsWrapper,
} from "./organizations.style";
import { IAction } from "venice-ui/dist/types/types";
import { ContractDetailsPanel } from "./ContractDetailsPanel";
import { UserManagementInContract } from "../Modals/UserManagementInContract";
import { ContractModal } from "../Modals/ContractModal";
import { DeleteContractModal } from "../Modals/DeleteContractModal";
import {
  getContractAndProjectIds,
  getContracts,
  IChangeProps,
  projectNNameFromOrganization,
} from "../../helpers/organizationHelper";
import {
  AddProjectModal,
  DeleteProjectModal,
  EditProjectModal,
} from "../Modals";
import { user } from "../../store/state/user";
import { IMemberAccess } from "../../store/interface/organization";
import { IProject } from "../../store/interface/projects";

interface IOrganizationsContracts {
  handleClick: () => void;
}

export const OrganizationsContracts: FC<IOrganizationsContracts> = ({
  handleClick,
}) => {
  const {
    id: orgID,
    contracts,
    members,
  } = useStoreState((state) => state.organization);
  const { uid } = useStoreState((state) => state.user.userDetails);
  const { updateContractsInUser } = useStoreActions((actions) => actions.user);

  const [selectedIDs, setSeletedIDs] = useState({
    contractID: "",
    projectID: "",
  });
  const handleSelect = (id: string) => {
    let contractID = "";
    let projectID = "";
    const findedContract = contracts.find(
      (_contract) => _contract.contractID === id,
    );
    if (findedContract) {
      contractID = findedContract.contractID;
      projectID = "";
    } else {
      contracts.forEach((_contract) => {
        const findedProject = _contract.projects?.find(
          (_project) => _project.projectID === id,
        );
        if (findedProject) {
          contractID = _contract.contractID;
          projectID = findedProject.projectID;
        }
      });
    }
    setSeletedIDs({ contractID, projectID });
  };

  const [userManagementModal, setUserManagementModal] = useState({
    show: false,
    contractID: "",
    projectID: "",
    type: "",
  });

  const [editModal, setEditModal] = useState({
    show: false,
    contractID: "",
    projectID: "",
    type: "",
  });
  const [deleteContractModal, setDeleteContractModal] = useState({
    show: false,
    contractID: "",
  });

  const [deleteProjectModal, setDeleteProjectModal] = useState({
    show: false,
    contractID: "",
    projectID: "",
  });

  const [addProjectModal, setAddProjectModal] = useState({
    show: false,
    contractID: "",
  });

  const { updateUserAccess } = useStoreActions(
    (actions) => actions.organization,
  );

  const { updateProjects } = useStoreActions((actions) => actions.projects);

  const showUserManagementModal = (id?: string) => {
    if (id) {
      const type = selectedIDs.projectID !== "" ? "project" : "contract";
      setUserManagementModal({
        show: true,
        contractID: selectedIDs.contractID,
        projectID: selectedIDs.projectID,
        type: type,
      });
    }
  };

  const hideUserManagementModal = () => {
    setUserManagementModal({
      show: false,
      contractID: "",
      projectID: "",
      type: "",
    });
  };

  const showEditModal = (id?: string) => {
    if (id) {
      const type = selectedIDs.projectID !== "" ? "project" : "contract";

      setEditModal({
        show: true,
        contractID: selectedIDs.contractID,
        projectID: selectedIDs.projectID,
        type: type,
      });
    }
  };

  const hideEditModal = () => {
    setEditModal({ show: false, contractID: "", projectID: "", type: "" });
  };

  const hideAddProjectModal = () => {
    setAddProjectModal({ show: false, contractID: "" });
  };

  const showDeleteContractModal = (id?: string) => {
    if (id) {
      setDeleteContractModal({ show: true, contractID: id });
    }
  };

  const hideDeleteContractModal = () => {
    setDeleteContractModal({ show: false, contractID: "" });
  };
  const showDeleteProjectModal = (id?: string) => {
    if (id) {
      const ids = getContractAndProjectIds(contracts, id);
      setDeleteProjectModal({
        show: true,
        contractID: ids.contractID,
        projectID: ids.projectID,
      });
    }
  };
  const hideDeleteProjectModal = () => {
    setDeleteProjectModal({
      show: false,
      contractID: "",
      projectID: "",
    });
  };

  const manageMember = async (changes: IChangeProps[]) => {
    const options = {
      orgID: orgID,
      changes: changes,
    };

    await apiCall(
      "organization/updateMemberInContract",
      options,
      (response: any) => {
        updateUserAccess(changes);

        changes.forEach((_change) => {
          if (_change.id === uid) {
            // update access in user => contracts
            updateContractsInUser({
              changes: _change.access as IMemberAccess[],
              contracts: response.contracts,
            });

            //update projects in projects => projects
            updateProjects({
              changes: _change.access as IMemberAccess[],
              projects: response.projects as IProject[],
            });
          }
        });

        hideUserManagementModal();
      },
    );
  };

  const handleUserManagement = (id?: string) => {
    if (id) {
      handleSelect(id);
      showUserManagementModal(id);
    }
  };
  const handleEdit = (id?: string) => {
    if (id) {
      handleSelect(id);
      showEditModal(id);
    }
  };

  const handleDelete = (id?: string) => {
    const ids = getContractAndProjectIds(contracts, id!);
    if (ids.projectID !== "") {
      showDeleteProjectModal(ids.projectID);
    } else {
      showDeleteContractModal(ids.contractID);
    }
  };

  const handleAddProject = (id?: string) => {
    if (id) {
      setAddProjectModal({ show: true, contractID: id });
    }
  };

  const contractActions: IAction[] = [
    {
      label: t(dictionary.userManagement),
      action: handleUserManagement,
    },
    {
      label: t(dictionary.addProject),
      action: handleAddProject,
    },
    {
      label: t(dictionary.changeName),
      action: handleEdit,
    },

    {
      label: t(dictionary.deleteContract),
      action: showDeleteContractModal,
    },
  ];
  const projectActions: IAction[] = [
    {
      label: t(dictionary.userManagement),
      action: handleUserManagement,
    },
    {
      label: t(dictionary.editProject),
      action: handleEdit,
    },
    {
      label: t(dictionary.deleteProject),
      action: showDeleteProjectModal,
    },
  ];

  const [contractList, setContractList] = useState<IListItem[]>(
    getContracts(contracts, members),
  );

  useEffect(() => {
    setContractList(getContracts(contracts, members));
  }, [contracts, members]);

  return (
    <>
      {contracts.length > 0 ? (
        <Aligment>
          <OrganizationsWrapper>
            <List
              isCollapsable
              isSelectable
              isStatus
              haveMoreOptions={true}
              items={contractList}
              handleChange={setContractList}
              handleSelect={handleSelect}
              selected={
                selectedIDs.projectID !== ""
                  ? selectedIDs.projectID
                  : selectedIDs.contractID
              }
              levelActions={[
                { level: 0, moreActions: contractActions },
                { level: 1, moreActions: projectActions },
              ]}
            />
          </OrganizationsWrapper>
          <OrganizationDetailsWrapper>
            <ContractDetailsPanel
              contractID={selectedIDs.contractID}
              projectID={selectedIDs.projectID}
              handleDelete={handleDelete}
              handleAddModal={showUserManagementModal}
              handleEditModal={showEditModal}
              handleAddProject={handleAddProject}
            />
          </OrganizationDetailsWrapper>
        </Aligment>
      ) : (
        <EmptyState
          title={t(dictionary.emptyStateContractsListTitle)}
          actionLabel={t(dictionary.addContract)}
          action={handleClick}
        />
      )}

      {userManagementModal.show && (
        <UserManagementInContract
          contractID={userManagementModal.contractID}
          projectID={userManagementModal.projectID}
          type={userManagementModal.type}
          handleCancel={hideUserManagementModal}
          handleConfirm={manageMember}
          isOpen={userManagementModal.show}
        />
      )}
      {editModal.show && (
        <>
          {editModal.type === "contract" ? (
            <ContractModal
              handleClose={hideEditModal}
              contractID={editModal.contractID}
              isOpen={editModal.show}
            />
          ) : (
            <EditProjectModal
              onClose={hideEditModal}
              projectID={editModal.projectID}
              show={editModal.show}
            />
          )}
        </>
      )}
      {deleteContractModal.show && (
        <DeleteContractModal
          id={deleteContractModal.contractID}
          handleCancel={hideDeleteContractModal}
          isOpen={deleteContractModal.show}
        />
      )}

      {addProjectModal.show && (
        <AddProjectModal
          onClose={hideAddProjectModal}
          contractID={addProjectModal.contractID}
          show={addProjectModal.show}
        />
      )}
      {deleteProjectModal.show && (
        <DeleteProjectModal
          handleCancel={() => hideDeleteProjectModal()}
          id={deleteProjectModal.projectID}
          name={projectNNameFromOrganization(
            contracts,
            deleteProjectModal.projectID,
          )}
          isOpen={deleteProjectModal.show}
        />
      )}
    </>
  );
};
